import { createModal } from "@commonlibs";
import clsx from "clsx";
import { useTranslate } from "ui/locale";
import PayTab from "../ScanModal/PayTab/PayTab";
import { PayModalRoot } from "./PayModal.styles";
import { PayModalProps } from "./PayModal.types";

const PayModal = createModal(({ className, ...rest }: PayModalProps) => {
    const translate = useTranslate();

    return (
        <PayModalRoot
            className={clsx("qr-modal", className)}
            header={{ left: "close-modal", title: translate("scan").toUpperCase() }}
            {...rest}
        >
            <PayTab />
        </PayModalRoot>
    );
});

export default PayModal;
